/**
 * Splide スライダー初期化（要素が存在する場合のみ）
 * Splide は common.js で window.Splide に格納済み
 */
export function init() {
	// wantedlyWorks スライダー（5枚・タブなし・自動再生）
	const wantedlyWorksEl = document.querySelector('.js-wantedly-works-slider');
	if (wantedlyWorksEl) {
		const wantedlyWorksSlider = new window.Splide(wantedlyWorksEl, {
			type: 'slide',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: true,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});
		wantedlyWorksSlider.mount();
	}

	// 強みカード CH スライダー
	const strongSliderEl = document.querySelector('.js-strong-slider');
	const strongTabs = document.querySelectorAll('.js-strong-tab');
	if (strongSliderEl && strongTabs.length) {
		const strongSlider = new window.Splide(strongSliderEl, {
			type: 'slide',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: false,
			autoplay: true,
			interval: 3000,
			pauseOnHover: true,
		});

		// CH タブクリックでスライド切替
		strongTabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				strongSlider.go(Number(tab.dataset.index));
			});
		});

		// スライド変更でタブのアクティブ状態を同期
		strongSlider.on('moved', function (newIndex) {
			strongTabs.forEach(function (tab, i) {
				const isActive = i === newIndex;
				tab.classList.toggle('topStrong__chTab--current', isActive);
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});
		});

		strongSlider.mount();
	}

	// creativeService スライダー（スマホモックアップ内 + カスタムドット）
	const serviceSliderEl = document.querySelector('.js-service-slider');
	if (serviceSliderEl) {
		const dotsWrap = serviceSliderEl.querySelector('.creativeService__dots');
		const slideCount = serviceSliderEl.querySelectorAll('.splide__slide').length;

		// カスタムドットを生成
		if (dotsWrap) {
			for (let i = 0; i < slideCount; i++) {
				const btn = document.createElement('button');
				btn.type = 'button';
				btn.className = 'creativeService__dot' + (i === 0 ? ' is-active' : '');
				btn.setAttribute('aria-label', (i + 1) + '枚目のスライドへ');
				btn.setAttribute('role', 'tab');
				btn.dataset.index = String(i);
				dotsWrap.appendChild(btn);
			}
		}

		const serviceSlider = new window.Splide(serviceSliderEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: true,
			autoplay: true,
			interval: 4000,
			pauseOnHover: true,
		});

		// ドットクリックでスライド移動
		if (dotsWrap) {
			dotsWrap.addEventListener('click', function (e) {
				const btn = e.target.closest('.creativeService__dot');
				if (btn) serviceSlider.go(Number(btn.dataset.index));
			});
		}

		// スライド変更でドットのアクティブ状態を同期
		serviceSlider.on('moved', function (newIndex) {
			if (!dotsWrap) return;
			dotsWrap.querySelectorAll('.creativeService__dot').forEach(function (dot, i) {
				dot.classList.toggle('is-active', i === newIndex);
			});
		});

		serviceSlider.mount();
	}

	// creativeFlow スライダー（Step タブ + スライド）
	const flowSliderEl = document.querySelector('.js-flow-slider');
	const flowTabs = document.querySelectorAll('.js-flow-tab');
	if (flowSliderEl && flowTabs.length) {
		const flowSlider = new window.Splide(flowSliderEl, {
			type: 'fade',
			rewind: true,
			speed: 400,
			pagination: false,
			arrows: false,
			drag: false,
			autoplay: false,
		});

		flowTabs.forEach(function (tab) {
			tab.addEventListener('click', function () {
				flowSlider.go(Number(tab.dataset.index));
			});
		});

		flowSlider.on('moved', function (newIndex) {
			flowTabs.forEach(function (tab, i) {
				const isActive = i === newIndex;
				tab.classList.toggle('creativeFlow__tab--current', isActive);
				tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});
			const tabsEl = document.querySelector('.js-flow-tabs');
			if (tabsEl) tabsEl.setAttribute('data-current', String(newIndex));
		});

		flowSlider.mount();
	}

	// 導入事例カード「めくる」スライダー
	const caseSliderEl = document.querySelector('.js-case-slider');
	const caseFlipBtn = document.querySelector('.js-case-flip');
	if (!caseSliderEl || !caseFlipBtn) return;

	const caseSlider = new window.Splide(caseSliderEl, {
		type: 'fade',
		rewind: true,
		speed: 0,          // CSS トランジションで制御するため Splide の speed は 0
		pagination: false,
		arrows: false,
		drag: false,
	});

	// フリップ（めくり）アニメーション
	const FLIP_DURATION = 600; // ms
	let isFlipping = false;

	caseFlipBtn.addEventListener('click', function () {
		if (isFlipping) return;
		isFlipping = true;

		const track = caseSliderEl.querySelector('.c-caseSlide__slideTrack');
		track.classList.add('is-flipping');

		// 半分(前面→側面)でスライドを切り替える
		setTimeout(function () {
			caseSlider.go('>');
		}, FLIP_DURATION / 2);

		// アニメーション完了後にクラスを外す
		setTimeout(function () {
			track.classList.remove('is-flipping');
			isFlipping = false;
		}, FLIP_DURATION);
	});

	caseSlider.mount();

	// Splide が track に overflow を付与するため、box-shadow が見えるよう上書き
	const track = caseSliderEl.querySelector('.splide__track');
	if (track) track.style.overflow = 'visible';
}
